// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"Bar_chartWrapper__FVySf"};